import { styled, Grid } from '@mui/material';

export const PageWrapper = styled(Grid)`
  position: relative;
  ${({ theme }) => theme.breakpoints.down('md')} {
    padding: 105px 23px 100px;
  }
  ${({ theme }) => theme.breakpoints.between('md', 'lg')} {
    padding: 153px 0 100px 0;
  }
`;
